// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"324":"845aab10fbfca28d7ae9","923":"4a1e5dbc246a4f00d7fb"}[chunkId] + ".bundle.js";
};